<template>
  <div class="about">
    <Banner :banner="banner" />
    <div class="container w1320">
      <div class="title">
        <div class="cn">企业简介</div>
        <div class="en">Company Profile</div>
      </div>
      <div class="about-fir">
        <div class="left wow">
          <div class="title">
		    		<div class="cn">欢迎来到博洋生活世界</div>
            <div class="en">Welcome to the world of Beyond</div>
		    	</div>
          <div class="content">
            <p>博洋纺织科技有限公司的前身是博洋家纺有限公司团购中心，于2017年正式独立运营。博洋纺织科技集研发、生产、采购、商务、质管、销售等部门于一体，这样能更好地满足客户需求。博洋纺织科技也一直秉持着不断超越，积极进取，突破自身局限的精神。坚持从产品前期调研、研发、推广、销售都做到精益求精，走在市场前沿。这样才更有足够的自信和体系支撑做到礼通天下，合作共赢。面对客户时，更是坚持卓越的产品品质、专业的服务态度。高效服务客户，把控好每个环节确保保质保量产出是我们一直信奉的使命。</p>
            <p>宁波博洋纺织科技的使命，精承博洋，礼通天下，不断超越，积极进取，突破自身局限。从产品前期调研，研发，推广销售都做到精益求精，走在市场前沿。更有足够的自信和体系支撑做到礼通天下，合作共赢。</p>
          </div>
        </div>
        <div class="right">
          <div class="img wow">
            <img src="@/assets/images/p7.png" alt="">
            <div class="video wow">
              <img src="@/assets/images/p8.png" alt="">
            </div>
            <div class="sign">World</div>
            <div class="content">
              <p>核心价值观；专业，高效，品质，超越，卓越的产品品质，专业的服务是企业的立足之本，也是企业的核心竞争力。不断的超越，创新贯穿始终，走在市场前沿。高效服务客户，把控好每个环节确保保质保量产出是我们的使命。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="title">
        <div class="cn">博洋生活</div>
        <div class="en">Beyond Live</div>
      </div>
      <div class="w1320">
        <div class="about-sec">
          <div class="left wow">
            <img src="@/assets/images/p9.png" alt="">
            <div class="sign">Beyond live</div>
          </div>
          <div class="right wow">
            <p>Beyond live 博洋生活”是博洋家纺旗下高端礼品家居品牌，以研发销售家居用品及室内装饰品为主。品牌基于博洋家纺在行业领先的产品研发、供应链管理能力，将富有特色的美学概念融入现代都市人群的健康生活哲学，研究满足礼品赠送需求的家居礼品，并力图引领行业的发展和创新。</p>
            <p>Beyond live的产品涉及卧室、餐具、浴室、客厅、各类礼品及装饰品等系列，包含但不限为商务、中国风、差旅便携等风格，秉承溯源、天然、匠心的产品研发理念，力求产品材质上乘、环保，设计新颖，大胆尝试新工艺新设计，呈现出富有特色且有市场竞争力的产品。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/components/Banner.vue'
export default {
  components: {
    Banner
  },
  data(){
    return{
      banner:{
        title:'博洋生活',
        img:'/images/aboutbanner.jpg'
      }
    }
  },
  methods: {
    
  }
}
</script>

<style scoped>
.about .container>.title{
  text-align: center;
  padding: 45px 0;
}
.about .container>.title .cn{
  font-family: '宋体';
  font-size: 30px;
  color: #5e7987;
  margin-bottom: 10px;
}
.about .container>.title .en{
  font-family: 'Embassy BT';
  font-size: 20px;
  color: #636363;
}
.about-fir{
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
}
.about-fir .left{
  width: 42.42%;
  padding: 260px 20px 0;
  position: relative;
	animation-name: transition1;
	animation-duration: 1s;
  animation-fill-mode:forwards;
}
.about-fir .left::after{
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 75.89%;
  height: 1px;
  background-color: #ced7db;
}
.about-fir .left .title{
  display: inline-block;
  text-align: center;
}
.about-fir .left .title .cn{
  font-family: '宋体';
  font-size: 30px;
  color: #5e7987;
  margin-bottom: 15px;
}
.about-fir .left .title .en{
  font-family: 'Embassy BT';
  font-size: 20px;
  color: #636363;
}
.about-fir .left .content{
  font-size: 12px;
  color: #6f6e6e;
  line-height: 35px;
  padding: 60px 0;
  text-indent: 2em;
}
.about-fir .right{
  width: 54.92%;
  margin-right: 2.66%;
  position: relative;
}
.about-fir .right .img{
  position: relative;
	animation-name: transition2;
	animation-duration: 1s;
  animation-fill-mode:forwards;
}
.about-fir .right .img img{
  display: block;
  width: 100%;
}
.about-fir .right .video{
  position: absolute;
  top: 64px;
  left: -240px;
  width: 455px;
	animation-name: transition2;
	animation-duration: 1s;
  animation-fill-mode:forwards;
}
.about-fir .right .video img{
  display: block;
  width: 100%;
}
.about-fir .right .sign{
  position: absolute;
  top: 49.22%;
  right: -35px;
  font-family: 'Embassy BT';
  font-size: 70px;
  color: #5e7987;
}
.about-fir .right .sign::after{
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 96px;
  height: 2px;
  margin-left: -48px;
  background-color: #5e7987;
}
.about-fir .right .content{
  font-size: 12px;
  color: #6f6e6e;
  line-height: 35px;
  margin-top: 100px;
  text-indent: 2em;
	animation-name: transition2;
	animation-duration: 1s;
  animation-fill-mode:forwards;
}
.about-sec{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-bottom: 100px;
}
.about-sec .left{
  width: 46.66%;
  margin-left: 7.12%;
  position: relative;
	animation-name: transition1;
	animation-duration: 1s;
  animation-fill-mode:forwards;
}
.about-sec .left img{
  display: block;
  width: 100%;
}
.about-sec .left .sign{
  position: absolute;
  bottom: 14.24%;
  left: -94px;
  font-family: 'Embassy BT';
  font-size: 70px;
  color: #5e7987;
}
.about-sec .left .sign::after{
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 96px;
  height: 2px;
  margin-left: -48px;
  background-color: #5e7987;
}
.about-sec .right{
  width: 46.22%;
  padding: 0 20px;
  font-size: 12px;
  color: #6f6e6e;
  line-height: 35px;
  text-indent: 2em;
	animation-name: transition2;
	animation-duration: 1s;
  animation-fill-mode:forwards;
}
@keyframes transition1 {
  0% {
    transform: translate(-100px,-100px);
    opacity: 0;
  }
  100% {
    transform: translate(0,0);
    opacity: 1;
  }
}
@keyframes transition2 {
  0% {
    transform: translate(100px,-100px);
    opacity: 0;
  }
  100% {
    transform: translate(0,0);
    opacity: 1;
  }
}
@media(max-width: 768px){
  .about-fir .left,
  .about-fir .right{
    width: 100%;
    margin: 0;
  }
  .about-fir .left{
    padding: 0 20px;
  }
  .about-fir .right .video{
    display: none;
  }
  .about-sec .left,
  .about-sec .right{
    width: 100%;
  }
}
</style>


